"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RowHeadCell_1 = __importDefault(require("./RowHeadCell"));

exports.default = RowHeadCell_1.default;